import { DragDropModule } from '@angular/cdk/drag-drop';
import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContentLoaderModule } from '@ngneat/content-loader';
import { AutofocusDirective } from '@ascschool/core/directives/autofocus.directive';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { QuillModule } from 'ngx-quill';
import { AscControlModule } from '../asc-control/asc-control.module';
import { HeaderComponent } from './components/header/header.component';
import { NavigationComponents } from './components/navigation';
import { ResizerComponent } from './components/navigation/resizer/resizer.component';
import { SearchDrawerComponent } from './components/search/search-drawer/search-drawer.component';
import { SettingDrawerComponent } from './components/menu-drawer/setting-drawer/setting-drawer.component';
import { UserComponent } from './components/user/user.component';
import { NZ_NDHUY_ICONS } from './config/icons';
import { BoardComponent } from './pages/board/board.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { ProjectRoutingModule } from './project-routing.module';
import { ProjectComponent } from './project.component';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { Sample1Component } from './pages/sample/sample1/sample1.component';
import { Sample2Component } from './pages/sample/sample2/sample2.component';
import { Sample5Component } from './pages/sample/sample5/sample5.component';
import { Sample9Component } from './pages/sample/sample9/sample9.component';
import { PopupComponent } from './pages/sample/sample1/popup/popup.component';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { DrawerComponent } from './pages/sample/sample1/drawer/drawer.component';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NzFormModule } from 'ng-zorro-antd/form';
import { ScoreConversionPipe } from './utils/scoreConversion.pipe';
import { Sample7Component } from './pages/sample/sample7/sample7.component';
import { Drawer7Component } from './pages/sample/sample7/drawer/drawer.component';
import { Popup7Component } from './pages/sample/sample7/popup/popup.component';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { PopupInfoComponent } from './pages/sample/sample7/popup-info/popup-info.component';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { ImportComponent } from './pages/sample/sample7/import/import.component';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { TabContentComponent } from './tabs/tab-content.component';
import { TabContentPopupComponent } from './tabs/tab-content-popup.componet';
import { TtCaNhanComponent } from './pages/sample/sample9/popup/add-personnel/tt-ca-nhan/tt-ca-nhan.component';
import { ContentContainerDirective } from './tabs/content-container.directive';
import { TabService } from './tabs/tab.service';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { SettingSchoolComponent } from './components/menu-drawer/setting-school/setting-school.component';
import { Sample8Component } from './pages/sample/sample8/sample8.component';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { AddStudentComponent } from './pages/sample/sample8/popup/add-student/add-student.component';
import { AddPersonnelComponent } from './pages/sample/sample9/popup/add-personnel/add-personnel.component';
import { NzCommentModule } from 'ng-zorro-antd/comment';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzTypographyModule } from 'ng-zorro-antd/typography';


import { HopDongComponent } from './pages/sample/sample9/popup/add-personnel/hop-dong/hop-dong.component';
import { TtLuongComponent } from './pages/sample/sample9/popup/add-personnel/tt-luong/tt-luong.component';
import { TrinhDoComponent } from './pages/sample/sample9/popup/add-personnel/trinh-do/trinh-do.component';
import { KhenthuongKyluatComponent } from './pages/sample/sample9/popup/add-personnel/khenthuong-kyluat/khenthuong-kyluat.component';
import { DemoComponent } from './pages/sample/sample9/popup/add-personnel/demo/demo.component';
import { DeletePersonelComponent } from './pages/sample/sample9/popup/delete-personel/delete-personel.component';
import { DeleteStudentComponent } from './pages/sample/sample8/popup/delete-student/delete-student.component';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { HighchartsChartModule } from 'highcharts-angular';
import { ScrollLayoutComponent } from './pages/sample/scroll-layout/scroll-layout.component';
import { ScrollLayoutNx1Component } from './pages/sample/scroll-layout-nx1/scroll-layout-nx1.component';
import { MenuOptionComponent } from './components/navigation/menu-option/menu-option.component';
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { TinhThanhComponent } from './pages/danh-muc-chung/tinh-thanh/tinh-thanh.component';
import { PopUpTinhThanhComponent } from './pages/danh-muc-chung/tinh-thanh/pop-up-tinh-thanh/pop-up-tinh-thanh.component';
import { ConfirmComponent } from './popups/confirm/confirm.component';
import { AscSelectComponent } from './components/asc-select/asc-select.component';
import { DangKhuyetTatComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/dang-khuyet-tat/dang-khuyet-tat.component';
import { PopUpDangKhuyetTatComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/dang-khuyet-tat/pop-up-dang-khuyet-tat/pop-up-dang-khuyet-tat.component';
import { MucDoComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/muc-do/muc-do.component';
import { PopUpMucDoComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/muc-do/pop-up-muc-do/pop-up-muc-do.component';
import { KetQuaHocTapComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/ket-qua-hoc-tap/ket-qua-hoc-tap.component';
import { PopUpKetQuaHocTapComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/ket-qua-hoc-tap/pop-up-ket-qua-hoc-tap/pop-up-ket-qua-hoc-tap.component';
import { ThanhTichComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/thanh-tich/thanh-tich.component';
import { PopUpThanhTichComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/thanh-tich/pop-up-thanh-tich/pop-up-thanh-tich.component';
import { GiaoTiepXaHoiComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/giao-tiep-xa-hoi/giao-tiep-xa-hoi.component';
import { PopUpGiaoTiepXaHoiComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/giao-tiep-xa-hoi/pop-up-giao-tiep-xa-hoi/pop-up-giao-tiep-xa-hoi.component';
import { QuanHuyenComponent } from './pages/danh-muc-chung/quan-huyen/quan-huyen.component';
import { PopupQuanHuyenComponent } from './pages/danh-muc-chung/quan-huyen/popup-quan-huyen/popup-quan-huyen.component';
import { KhaNangTuPhucVuComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/kha-nang-tu-phuc-vu/kha-nang-tu-phuc-vu.component';
import { PopUpKhaNangTuPhucVuComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/kha-nang-tu-phuc-vu/pop-up-kha-nang-tu-phuc-vu/pop-up-kha-nang-tu-phuc-vu.component';
import { HieuQuaHoTroYTeComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/hieu-qua-ho-tro-y-te/hieu-qua-ho-tro-y-te.component';
import { PopUpHieuQuaHoTroYTeComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/hieu-qua-ho-tro-y-te/pop-up-hieu-qua-ho-tro-y-te/pop-up-hieu-qua-ho-tro-y-te.component';
import { NguoiChamSocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/nguoi-cham-soc/nguoi-cham-soc.component';
import { PopUpNguoiChamSocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/nguoi-cham-soc/pop-up-nguoi-cham-soc/pop-up-nguoi-cham-soc.component';
import { NhuCauNKTComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/nhu-cau-nkt/nhu-cau-nkt.component';
import { PopUpNhuCauNKTComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/nhu-cau-nkt/pop-up-nhu-cau-nkt/pop-up-nhu-cau-nkt.component';
import { ThongTinYTeComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/thong-tin-y-te/thong-tin-y-te.component';
import { PopUpThongTinYTeComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/thong-tin-y-te/pop-up-thong-tin-y-te/pop-up-thong-tin-y-te.component';
import { DieuKienSongComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/dieu-kien-song/dieu-kien-song.component';
import { PopUpDieuKienSongComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/dieu-kien-song/pop-up-dieu-kien-song/pop-up-dieu-kien-song.component';
import { PhuongXaComponent } from './pages/danh-muc-chung/phuong-xa/phuong-xa.component';
import { PopupPhuongXaComponent } from './pages/danh-muc-chung/phuong-xa/popup-phuong-xa/popup-phuong-xa.component';
import { ThuNhapHangThangComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/thu-nhap-hang-thang/thu-nhap-hang-thang.component';
import { PopUpThuNhapHangThangComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/thu-nhap-hang-thang/pop-up-thu-nhap-hang-thang/pop-up-thu-nhap-hang-thang.component';
import { NguonThuNhapChinhComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/nguon-thu-nhap-chinh/nguon-thu-nhap-chinh.component';
import { PopUpNguonThuNhapChinhComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/nguon-thu-nhap-chinh/pop-up-nguon-thu-nhap-chinh/pop-up-nguon-thu-nhap-chinh.component';
import { ChiTraHoTroNKTComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/chi-tra-ho-tro-nkt/chi-tra-ho-tro-nkt.component';
import { PopUpChiTraHoTroNKTComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/chi-tra-ho-tro-nkt/pop-up-chi-tra-ho-tro-nkt/pop-up-chi-tra-ho-tro-nkt.component';
import { DocLapVeKinhTeComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/doc-lap-ve-kinh-te/doc-lap-ve-kinh-te.component';
import { PopUpDocLapVeKinhTeComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/doc-lap-ve-kinh-te/pop-up-doc-lap-ve-kinh-te/pop-up-doc-lap-ve-kinh-te.component';
import { TrinhDoHocVanComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/trinh-do-hoc-van/trinh-do-hoc-van.component';
import { PopUpTrinhDoHocVanComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/trinh-do-hoc-van/pop-up-trinh-do-hoc-van/pop-up-trinh-do-hoc-van.component';
import { DichVuThamGiaComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/dich-vu-tham-gia/dich-vu-tham-gia.component';
import { PopUpDichVuThamGiaComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/dich-vu-tham-gia/pop-up-dich-vu-tham-gia/pop-up-dich-vu-tham-gia.component';
import { TinhTrangGiaoDucComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/tinh-trang-giao-duc/tinh-trang-giao-duc.component';
import { PopUpTinhTrangGiaoDucComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/tinh-trang-giao-duc/pop-up-tinh-trang-giao-duc/pop-up-tinh-trang-giao-duc.component';
import { LoaiHinhGiaoDucThamGiaComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/loai-hinh-giao-duc-tham-gia/loai-hinh-giao-duc-tham-gia.component';
import { PopUpLoaiHinhGiaoDucThamGiaComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/loai-hinh-giao-duc-tham-gia/pop-up-loai-hinh-giao-duc-tham-gia/pop-up-loai-hinh-giao-duc-tham-gia.component';
import { LoaiHinhToChucComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/loai-hinh-to-chuc/loai-hinh-to-chuc.component';
import { PopUpLoaiHinhToChucComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/loai-hinh-to-chuc/pop-up-loai-hinh-to-chuc/pop-up-loai-hinh-to-chuc.component';
import { HinhThucHoTroComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/hinh-thuc-ho-tro/hinh-thuc-ho-tro.component';
import { PopUpHinhThucHoTroComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/hinh-thuc-ho-tro/pop-up-hinh-thuc-ho-tro/pop-up-hinh-thuc-ho-tro.component';
import { NgheNghiepComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/nghe-nghiep/nghe-nghiep.component';
import { PopUpNgheNghiepComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/nghe-nghiep/pop-up-nghe-nghiep/pop-up-nghe-nghiep.component';
import { MucDoQuanTamGiaDinhComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/muc-do-quan-tam-gia-dinh/muc-do-quan-tam-gia-dinh.component';
import { PopUpMucDoQuanTamGiaDinhComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/muc-do-quan-tam-gia-dinh/pop-up-muc-do-quan-tam-gia-dinh/pop-up-muc-do-quan-tam-gia-dinh.component';
import { DeXuatKienNghiComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/de-xuat-kien-nghi/de-xuat-kien-nghi.component';
import { PopUpDeXuatKienNghiComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/de-xuat-kien-nghi/pop-up-de-xuat-kien-nghi/pop-up-de-xuat-kien-nghi.component';
import { DieuKienThamGiaGDComponent } from './pages/danh-muc-nhan-su/dieu-kien-tham-gia-giao-duc/dieu-kien-tham-gia-giao-duc.component';
import { PopUpDieuKienThamGiaGDComponent } from './pages/danh-muc-nhan-su/dieu-kien-tham-gia-giao-duc/pop-up-dieu-kien-tham-gia-giao-duc/pop-up-dieu-kien-tham-gia-giao-duc.component';
import { DanTocComponent } from './pages/danh-muc-chung/dan-toc/dan-toc.component';
import { PopupDanTocComponent } from './pages/danh-muc-chung/dan-toc/popup-dan-toc/popup-dan-toc.component';
import { TonGiaoComponent } from './pages/danh-muc-chung/ton-giao/ton-giao.component';
import { PopupTonGiaoComponent } from './pages/danh-muc-chung/ton-giao/popup-ton-giao/popup-ton-giao.component';
import { HinhThucHocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/hinh-thuc-hoc/hinh-thuc-hoc.component';
import { PopUpHinhThucHocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/hinh-thuc-hoc/pop-up-hinh-thuc-hoc/pop-up-hinh-thuc-hoc.component';
import { LopHocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/lop-hoc/lop-hoc.component';
import { PopUpLopHocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/lop-hoc/pop-up-lop-hoc/pop-up-lop-hoc.component';
import { LopHocNienHocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/lop-hoc-nien-hoc/lop-hoc-nien-hoc.component';
import { PopUpLopHocNienHocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/lop-hoc-nien-hoc/pop-up-lop-hoc-nien-hoc/pop-up-lop-hoc-nien-hoc.component';
import { CapTrucThuocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/cap-truc-thuoc/cap-truc-thuoc.component';
import { PopUpCapTrucThuocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/cap-truc-thuoc/pop-up-cap-truc-thuoc/pop-up-cap-truc-thuoc.component';
import { PhuongThucGiaoDucComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/phuong-thuc-giao-duc/phuong-thuc-giao-duc.component';
import { PopUpPhuongThucGiaoDucComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/phuong-thuc-giao-duc/pop-up-phuong-thuc-giao-duc/pop-up-phuong-thuc-giao-duc.component';
import { QuocTichComponent } from './pages/danh-muc-chung/quoc-tich/quoc-tich.component';
import { PopupQuocTichComponent } from './pages/danh-muc-chung/quoc-tich/popup-quoc-tich/popup-quoc-tich.component';
import { PopupNienHocComponent } from './pages/danh-muc-chung/nien-hoc/popup-nien-hoc/popup-nien-hoc.component';
import { NienHocComponent } from './pages/danh-muc-chung/nien-hoc/nien-hoc.component';
import { LoaiNhanSuComponent } from './pages/danh-muc-nhan-su/loai-nhan-su/loai-nhan-su.component';
import { PopUpLoaiNhanSuComponent } from './pages/danh-muc-nhan-su/loai-nhan-su/pop-up-loai-nhan-su/pop-up-loai-nhan-su.component';
import { ChucVuComponent } from './pages/danh-muc-nhan-su/chuc-vu/chuc-vu.component';
import { PopUpChucVuComponent } from './pages/danh-muc-nhan-su/chuc-vu/pop-up-chuc-vu/pop-up-chuc-vu.component';
import { TrinhDoChuyenmonComponent } from './pages/danh-muc-nhan-su/trinh-do-chuyen-mon/trinh-do-chuyen-mon.component';
import { PopUpTrinhDoChuyenMonComponent } from './pages/danh-muc-nhan-su/trinh-do-chuyen-mon/pop-up-trinh-do-chuyen-mon/pop-up-trinh-do-chuyen-mon.component';
import { ChuyenNganhDaoTaoComponent } from './pages/danh-muc-nhan-su/chuyen-nganh-dao-tao/chuyen-nganh-dao-tao.component';
import { PopUpChuyenNganhDaoTaoComponent } from './pages/danh-muc-nhan-su/chuyen-nganh-dao-tao/pop-up-chuyen-nganh-dao-tao/pop-up-chuyen-nganh-dao-tao.component';
import { LoaiCoSoComponent } from './pages/danh-muc-thuoc-don-vi/loai-co-so/loai-co-so.component';
import { PopupLoaiCoSoComponent } from './pages/danh-muc-thuoc-don-vi/loai-co-so/popup-loai-co-so/popup-loai-co-so.component';
import { LoaiHinhComponent } from './pages/danh-muc-thuoc-don-vi/loai-hinh/loai-hinh.component';
import { PopupLoaiHinhComponent } from './pages/danh-muc-thuoc-don-vi/loai-hinh/popup-loai-hinh/popup-loai-hinh.component';
import { KhuVucComponent } from './pages/danh-muc-thuoc-don-vi/khu-vuc/khu-vuc.component';
import { PopupKhuVucComponent } from './pages/danh-muc-thuoc-don-vi/khu-vuc/popup-khu-vuc/popup-khu-vuc.component';
import { NgachComponent } from './pages/danh-muc-nhan-su/ngach/ngach.component';
import { PopUpNgachComponent } from './pages/danh-muc-nhan-su/ngach/pop-up-ngach/pop-up-ngach.component';
import { BacComponent } from './pages/danh-muc-nhan-su/bac/bac.component';
import { PopUpBacComponent } from './pages/danh-muc-nhan-su/bac/pop-up-bac/pop-up-bac.component';
import { PhongBanComponent } from './pages/danh-muc-nhan-su/phong-ban/phong-ban.component';
import { PopUpPhongBanComponent } from './pages/danh-muc-nhan-su/phong-ban/pop-up-phong-ban/pop-up-phong-ban.component';
import { TrangThaiCanBoComponent } from './pages/danh-muc-nhan-su/trang-thai-can-bo/trang-thai-can-bo.component';
import { PopUpTrangThaiCanBoComponent } from './pages/danh-muc-nhan-su/trang-thai-can-bo/pop-up-trang-thai-can-bo/pop-up-trang-thai-can-bo.component';
import { MonHocComponent } from './pages/danh-muc-nhan-su/mon-hoc/mon-hoc.component';
import { PopUpMonHocComponent } from './pages/danh-muc-nhan-su/mon-hoc/pop-up-mon-hoc/pop-up-mon-hoc.component';
import { CapHocComponent } from './pages/danh-muc-nhan-su/cap-hoc/cap-hoc.component';
import { PopUpCapHocComponent } from './pages/danh-muc-nhan-su/cap-hoc/pop-up-cap-hoc/pop-up-cap-hoc.component';
import { LoaiHopDongComponent } from './pages/danh-muc-nhan-su/loai-hop-dong/loai-hop-dong.component';
import { PopUpLoaiHopDongComponent } from './pages/danh-muc-nhan-su/loai-hop-dong/pop-up-loai-hop-dong/pop-up-loai-hop-dong.component';
import { ThongTinNhanSuComponent } from './pages/thong-tin-nhan-su/thong-tin-nhan-su.component';
import { PopupThemTtnsComponent } from './pages/thong-tin-nhan-su/popup-them-ttns/popup-them-ttns.component';
import { PopupXemTtnsComponent } from './pages/thong-tin-nhan-su/popup-xem-ttns/popup-xem-ttns.component';
import { PopupTtnsComponent } from './pages/thong-tin-nhan-su/popup-ttns/popup-ttns.component';
import { PopupImportTtnsComponent } from './pages/thong-tin-nhan-su/popup-import-ttns/popup-import-ttns.component';
import { HocSinhComponent } from './pages/thong-tin-nguoi-khuyet-tat/hoc-sinh.component';
import { StudentAddPopupComponent } from './pages/thong-tin-nguoi-khuyet-tat/them-hoc-sinh-popup/student-add-popup.component';
import { CertificateTakeCareOfStudentAddPopupComponent } from './pages/thong-tin-nguoi-khuyet-tat/them-hoc-sinh-popup/certificate-take-care-of-student-add-popup/certificate-take-care-of-student-add-popup.component';
import { StudentLearningProcessAddPopupComponent } from './pages/thong-tin-nguoi-khuyet-tat/them-hoc-sinh-popup/student-learning-process-add-popup/student-learning-process-add-popup.component';
import { PolicyOfStudentAddPopupComponent } from './pages/thong-tin-nguoi-khuyet-tat/them-hoc-sinh-popup/policy-of-student-add-popup/policy-of-student-add-popup.component';
import { TeacherInChargeAddPopupComponent } from './pages/thong-tin-nguoi-khuyet-tat/them-hoc-sinh-popup/teacher-in-charge-add-popup/teacher-in-charge-add-popup.component';
import { DisbilityOfStudentAddPopupComponent } from './pages/thong-tin-nguoi-khuyet-tat/them-hoc-sinh-popup/disbility-of-student-add-popup/disbility-of-student-add-popup.component';
import { StudentPopupComponent } from './pages/thong-tin-nguoi-khuyet-tat/sua-hoc-sinh-popup/student-popup.component';
import { CertificateTakeCareOfStudentPopupComponent } from './pages/thong-tin-nguoi-khuyet-tat/sua-hoc-sinh-popup/certificate-take-care-of-student-popup/certificate-take-care-of-student-popup.component';
import { StudentLearningProcessPopupComponent } from './pages/thong-tin-nguoi-khuyet-tat/sua-hoc-sinh-popup/student-learning-process-popup/student-learning-process-popup.component';
import { PolicyOfStudentPopupComponent } from './pages/thong-tin-nguoi-khuyet-tat/sua-hoc-sinh-popup/policy-of-student-popup/policy-of-student-popup.component';
import { TeacherInChargePopupComponent } from './pages/thong-tin-nguoi-khuyet-tat/sua-hoc-sinh-popup/teacher-in-charge-popup/teacher-in-charge-popup.component';
import { DisbilityOfStudentPopupComponent } from './pages/thong-tin-nguoi-khuyet-tat/sua-hoc-sinh-popup/disbility-of-student-popup/disbility-of-student-popup.component';

import { NhomNguoiDungComponent } from './pages/quan-tri-he-thong/nhom-nguoi-dung/nhom-nguoi-dung.component';
import { NhomQuanTriComponent } from './pages/quan-tri-he-thong/nhom-quan-tri/nhom-quan-tri.component';

import { SignInComponent } from './pages/sign-in/sign-in.component';

import { PopUpTrungTamGDDBComponent } from './pages/thong-tin-don-vi/trung-tam-gddb/pop-up-trung-tam-gddb/pop-up-trung-tam-gddb.component';
import { ThemTrungTamGDDBComponent } from './pages/thong-tin-don-vi/trung-tam-gddb/them-trung-tam-gddb/them-trung-tam-gddb.component';
import { XemTrungTamGDDBComponent } from './pages/thong-tin-don-vi/trung-tam-gddb/xem-trung-tam-gddb/xem-trung-tam-gddb.component';
import { TrungTamGDDBComponent } from './pages/thong-tin-don-vi/trung-tam-gddb/trung-tam-gddb.component';
import { DonViQuanLyComponent } from './pages/thong-tin-don-vi/don-vi-quan-ly/don-vi-quan-ly.component';
import { XemDonViQuanLyComponent } from './pages/thong-tin-don-vi/don-vi-quan-ly/xem-don-vi-quan-ly/xem-don-vi-quan-ly.component';
import { ThemDonViQuanLyComponent } from './pages/thong-tin-don-vi/don-vi-quan-ly/them-don-vi-quan-ly/them-don-vi-quan-ly.component';
import { PopUpDonViQuanLyComponent } from './pages/thong-tin-don-vi/don-vi-quan-ly/pop-up-don-vi-quan-ly/pop-up-don-vi-quan-ly.component';
import { CoSoComponent } from './pages/thong-tin-don-vi/co-so/co-so.component';
import { PopupThemChungChiComponent } from './pages/thong-tin-nhan-su/popup-them-ttns/popup-them-chung-chi/popup-them-chung-chi.component';
import { PopupChungChiComponent } from './pages/thong-tin-nhan-su/popup-ttns/popup-chung-chi/popup-chung-chi.component';
import { PhanQuyenChucNangComponent } from './pages/quan-tri-he-thong/phan-quyen-chuc-nang/phan-quyen-chuc-nang.component';
import { StudentImportPupupComponent } from './pages/thong-tin-nguoi-khuyet-tat/import-hoc-sinh/pop-up-import-hoc-sinh.component';
import { StudentViewComponent } from './pages/thong-tin-nguoi-khuyet-tat/xem-hoc-sinh/student-view.component';
import { XemCoSoComponent } from './pages/thong-tin-don-vi/co-so/xem-co-so/xem-co-so.component';
import { ThemCoSoComponent } from './pages/thong-tin-don-vi/co-so/them-co-so/them-co-so.component';
import { PopUpCoSoComponent } from './pages/thong-tin-don-vi/co-so/pop-up-co-so/pop-up-co-so.component';
import { PopUpNhomNguoiDungComponent } from './pages/quan-tri-he-thong/nhom-nguoi-dung/pop-up-nhom-nguoi-dung/pop-up-nhom-nguoi-dung.component';
import { QuanLyDanhSachCoSoComponent } from './pages/quan-tri-he-thong/nhom-nguoi-dung/quan-ly-danh-sach-co-so/quan-ly-danh-sach-co-so.component';
import { PhanQuyenNhomNguoiDungComponent } from './pages/quan-tri-he-thong/nhom-nguoi-dung/phan-quyen-nhom-nguoi-dung/phan-quyen-nhom-nguoi-dung.component';
import { PopupNhomQuanTriComponent } from './pages/quan-tri-he-thong/nhom-quan-tri/popup-nqt/popup-nqt.component';
import { NguoiDungHeThongComponent } from './pages/quan-tri-he-thong/nguoi-dung-he-thong/nguoi-dung-he-thong.component';
import { ThemNguoiDungHeThongComponent } from './pages/quan-tri-he-thong/nguoi-dung-he-thong/them-nguoi-dung-he-thong/them-nguoi-dung-he-thong.component';
import { GenderPipe } from '@ascschool/pipe/gender.pipe';
import { KeysPipe } from '@ascschool/pipe/keys.pipe';
import { DynamicPipe } from '@ascschool/pipe/dynamicPype.pipe';
import { PopUpNguoiDungHeThongComponent } from './pages/quan-tri-he-thong/nguoi-dung-he-thong/pop-up-nguoi-dung-he-thong/pop-up-nguoi-dung-he-thong.component';
import { QuanLyDanhSachNguoiDungHeThongComponent } from './pages/quan-tri-he-thong/nguoi-dung-he-thong/quan-ly-danh-sach-co-so/quan-ly-danh-sach-co-so.component';
import { PhanQuyenNguoiDungHeThongComponent } from './pages/quan-tri-he-thong/nguoi-dung-he-thong/phan-quyen-nhom-nguoi-dung/phan-quyen-nhom-nguoi-dung.component';
import { QuanLyTkTrungTamGDDBComponent } from './pages/quan-tri-he-thong/quan-ly-tk-trung-tam-gddb/quan-ly-tk-trung-tam-gddb.component';
import { CapNhatMatKhauComponent } from './pages/quan-tri-he-thong/cap-nhat-mat-khau/cap-nhat-mat-khau.component';
import { QuanLyTkDonViQuanLyComponent } from './pages/quan-tri-he-thong/quan-ly-tk-don-vi-quan-ly/quan-ly-tk-don-vi-quan-ly.component';
import { QuanLyTkCoSoComponent } from './pages/quan-tri-he-thong/quan-ly-tk-co-so/quan-ly-tk-co-so.component';
import { PopUpGiaoVienPhuTrachComponent } from './pages/phan-cong-giao-vien-phu-trach/popup-giao-vien-phu-trach/popup-giao-vien-phu-trach.component';
import { ChinhSuaLopHocNienHocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/lop-hoc-nien-hoc/chinh-sua-lop-hoc-nien-hoc/chinh-sua-lop-hoc-nien-hoc.component';
import { PhanNhomQuyenComponent } from './pages/quan-tri-he-thong/nguoi-dung-he-thong/phan-nhom-quyen/phan-nhom-quyen.component';
import { PhanCongGiaoVienPhuTrachComponent } from './pages/phan-cong-giao-vien-phu-trach/phan-cong-giao-vien-phu-trach.component';
import { ThemGiaoVienPhuTrachComponent } from './pages/phan-cong-giao-vien-phu-trach/them-giao-vien-phu-trach/them-giao-vien-phu-trach.component';
import { BcCsGiaoDucComponent } from './pages/bao-cao/bc-cs-giao-duc/bc-cs-giao-duc.component';
import { TongHopTtVeNktComponent } from './pages/bao-cao/tong-hop-tt-ve-nkt/tong-hop-tt-ve-nkt.component';
import { ThCbqlGvCbdhNktComponent } from './pages/bao-cao/th-cbql-gv-cbdh-nkt/th-cbql-gv-cbdh-nkt.component';
import { ThongKeGdNktComponent } from './pages/bao-cao/thong-ke-gd-nkt/thong-ke-gd-nkt.component';
import { BcTtHtGdhnComponent } from './pages/bao-cao/bc-tt-ht-gdhn/bc-tt-ht-gdhn.component';
import { BcCsgdComponent } from './pages/bao-cao/bc-csgd/bc-csgd.component';
import { PhanHeComponent } from './pages/danh-muc-thuoc-don-vi/phan-he/phan-he.component';
import { PopupPhanHeComponent } from './pages/danh-muc-thuoc-don-vi/phan-he/popup-phan-he/popup-phan-he.component';
import { VanBangComponent } from './pages/danh-muc-nhan-su/van-bang/van-bang.component';
import { PopupVanBangComponent } from './pages/danh-muc-nhan-su/van-bang/popup-van-bang/popup-van-bang.component';
import { DanhSachNguoiKhuyetTatComponent } from './pages/phan-cong-giao-vien-phu-trach/danh-sach-nkt/danh-sach-nkt.component';
import { ThemNguoiKhuyetTatComponent } from './pages/phan-cong-giao-vien-phu-trach/them-nkt/them-nkt.component';
import { PageBtnSearchComponent } from './components/page-btn-search/page-btn-search.component';
import { PageBtnOptionComponent } from './components/page-btn-option/page-btn-option.component';
import { TableBtnRowComponent } from './components/table-btn-row/table-btn-row.component';
import { ThongTinNguoiDungComponent } from './pages/thong-tin-tai-khoan/thong-tin-nguoi-dung/thong-tin-nguoi-dung.component';
import { DoiMatKhauComponent } from './pages/thong-tin-tai-khoan/doi-mat-khau/doi-mat-khau.component';
import { TableBasicComponent } from './components/table-basic/table-basic.component';
import { PageBtnOptionExtendComponent } from './components/page-btn-option-extend/page-btn-option-extend.component';
import { PhieuHoiGdNktComponent } from './pages/phieu/phieu-hoi-gd-nkt/phieu-hoi-gd-nkt.component';
import { DisDisabilityCertificateTypePipe } from '@ascschool/pipe/disDisabilityCertificateType.pipe';
import { TableBtnRowExtendComponent } from './components/table-btn-row-extend/table-btn-row-extend.component';
import { SelectAutocompleteComponent } from './components/select-autocomplete/select-autocomplete.component';
import { PopupBtnFooterComponent } from './components/popup-btn-footer/popup-btn-footer.component';
import { FormComponent } from './components/dynamic-form';
import { EducationAndTrainingForPipe } from '@ascschool/pipe/educationAndTrainingFor.pipe';
import { TrichXuatThongTinPupupComponent } from './pages/thong-tin-nguoi-khuyet-tat/trich-xuat-thong-tin/pop-up-trich-xuat-thong-tin.component';
import { MailComponent } from './pages/mail';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { ThongBaoComponent } from './pages/thong-tin-tai-khoan/thong-bao/thong-bao.component';
import { PopupThongBaoComponent } from './pages/thong-tin-tai-khoan/thong-bao/popup-thong-bao/popup-thong-bao.component';
import { PopupUnViewThongBaoComponent } from './pages/thong-tin-tai-khoan/thong-bao/popup-unview-thong-bao/popup-unview-thong-bao.component';
import { PopupViewThongBaoComponent } from './pages/thong-tin-tai-khoan/thong-bao/popup-view-thong-bao/popup-view-thong-bao.component';
import { ExceptionComponent } from './pages/exception/exception.component';
import { PopupXemNoiDungThongBaoComponent } from './pages/thong-tin-tai-khoan/thong-bao/popup-view-noi-dung-thong-bao/popup-view-noi-dung-thong-bao.component';
import { NguyenNhanComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/nguyen-nhan/nguyen-nhan.component';
import { PopupNguyenNhanComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/nguyen-nhan/popup-nguyen-nhan/popup-nguyen-nhan.component';
import { LoaiChungNhanComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/loai-chung-nhan/loai-chung-nhan.component';
import { PopupLoaiChungNhanComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/loai-chung-nhan/popup-loai-chung-nhan/popup-loai-chung-nhan.component';
import { PopupTrinhDoDMComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/trinh-do/popup-trinh-do/popup-trinh-do.component';
import { TrinhDoDMComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/trinh-do/trinh-do.component';
import { ConvertDatePipe } from '@ascschool/pipe/convert-date.pipe';
import { SchoolImportPupupComponent } from './pages/thong-tin-don-vi/co-so/import-co-so/pop-up-import-co-so.component';
import { TinhTrangHonNhanComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/tinh-trang-hon-nhan/tinh-trang-hon-nhan.component';
import { PopupTinhTrangHonNhanComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/tinh-trang-hon-nhan/popup-tinh-trang-hon-nhan/popup-tinh-trang-hon-nhan.component';
import { TinhTrangViecLamComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/tinh-trang-viec-lam/tinh-trang-viec-lam.component';
import { PopupTinhTrangViecLamComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/tinh-trang-viec-lam/popup-tinh-trang-viec-lam/popup-tinh-trang-viec-lam.component';
import { MucDoPhatTrienComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/muc-do-phat-trien/muc-do-phat-trien.component';
import { PopupMucDoPhatTrienComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/muc-do-phat-trien/popup-muc-do-phat-trien/popup-muc-do-phat-trien.component';
import { PopupLinhVucComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/linh-vuc/popup-linh-vuc/popup-linh-vuc.component';
import { LinhVucComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/linh-vuc/linh-vuc.component';
import { PopupLevelOfDevComponent } from './pages/thong-tin-nguoi-khuyet-tat/them-hoc-sinh-popup/popup-level-of-dev/popup-level-of-dev.component';
import { PopupEditLevelOfDevComponent } from './pages/thong-tin-nguoi-khuyet-tat/sua-hoc-sinh-popup/popup-edit-level-of-dev/popup-edit-level-of-dev.component';
import { PhieuHoiNktComponent } from './pages/phieu/phieu-hoi-nkt/phieu-hoi-nkt.component';
import { DsPhieuKhaoSatComponent } from './pages/phieu/quan-ly/ds-phieu-khao-sat/ds-phieu-khao-sat.component';
import { PopupDsPhieuKhaoSatComponent } from './pages/phieu/quan-ly/ds-phieu-khao-sat/popup-ds-phieu-khao-sat/popup-ds-phieu-khao-sat.component';
import { DanhMucKhaoSatComponent } from './pages/danh-muc-khao-sat';
import { DvqlCapQuanHuyenComponent } from './pages/thong-tin-don-vi/dvql-cap-quan-huyen/dvql-cap-quan-huyen.component';
import { SuaDvqlCapQuanHuyenComponent } from './pages/thong-tin-don-vi/dvql-cap-quan-huyen/sua-dvql-cap-quan-huyen/sua-dvql-cap-quan-huyen.component';
import { QuanLyTkDvqlQuanHuyenComponent } from './pages/quan-tri-he-thong/quan-ly-tk-dvql-quan-huyen/quan-ly-tk-dvql-quan-huyen.component';
import { XemDvqlCapQuanHuyenComponent } from './pages/thong-tin-don-vi/dvql-cap-quan-huyen/xem-dvql-cap-quan-huyen/xem-dvql-cap-quan-huyen.component';
import { ThemDvqlCapQuanHuyenComponent } from './pages/thong-tin-don-vi/dvql-cap-quan-huyen/them-dvql-cap-quan-huyen/them-dvql-cap-quan-huyen.component';
import { CamOnKhaoSatComponent } from './pages/phieu/cam-on-khao-sat/cam-on-khao-sat.component';
import { NzResultModule } from 'ng-zorro-antd/result';
import { PhieuDanhGiaNktComponent } from './pages/phieu/quan-ly/phieu-danh-gia-nkt/phieu-danh-gia-nkt.component';
import { CoSoHaTangComponent } from './pages/danh-muc-thuoc-don-vi/co-so-ha-tang/co-so-ha-tang.component';
import { PopupCoSoHaTangComponent } from './pages/danh-muc-thuoc-don-vi/co-so-ha-tang/popup-co-so-ha-tang/popup-co-so-ha-tang.component';
import { LoaiPhuongTienHocLieuComponent } from './pages/danh-muc-thuoc-don-vi/loai-phuong-tien-hoc-lieu/loai-phuong-tien-hoc-lieu.component';
import { PopupLoaiPhuongTienComponent } from './pages/danh-muc-thuoc-don-vi/loai-phuong-tien-hoc-lieu/popup-loai-phuong-tien/popup-loai-phuong-tien.component';
import { NoiDungDtbdcsgdhtgdComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/noi-dung-dtbdcsgdhtgd/noi-dung-dtbdcsgdhtgd.component';
import { PopupNoiDungDtbdcsgdhtgdComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/noi-dung-dtbdcsgdhtgd/popup-noi-dung-dtbdcsgdhtgd/popup-noi-dung-dtbdcsgdhtgd.component';
import { PopupMoiQuanHeVoiNktComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/moi-quan-he-voi-nkt/popup-moi-quan-he-voi-nkt/popup-moi-quan-he-voi-nkt.component';
import { MoiQuanHeVoiNktComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/moi-quan-he-voi-nkt/moi-quan-he-voi-nkt.component';
import { LoaiDtbdcsgdhtgdComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/loai-dtbdcsgdhtgd/loai-dtbdcsgdhtgd.component';
import { PopupDtbdcsgdhtgdComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/loai-dtbdcsgdhtgd/popup-dtbdcsgdhtgd/popup-dtbdcsgdhtgd.component';
import { LoaiKyNangComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/loai-ky-nang/loai-ky-nang.component';
import { PopupLoaiKyNangComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/loai-ky-nang/popup-loai-ky-nang/popup-loai-ky-nang.component';
import { CheDoThamGiaGdNktComponent } from './pages/danh-muc-nhan-su/che-do-tham-gia-gd-nkt/che-do-tham-gia-gd-nkt.component';
import { PopupCheDoThamGiaComponent } from './pages/danh-muc-nhan-su/che-do-tham-gia-gd-nkt/popup-che-do-tham-gia/popup-che-do-tham-gia.component';
import { HoatDongVaHoTroNktComponent } from './pages/danh-muc-nhan-su/hoat-dong-va-ho-tro-nkt/hoat-dong-va-ho-tro-nkt.component';
import { PopupHoatDongVaHoTroNktComponent } from './pages/danh-muc-nhan-su/hoat-dong-va-ho-tro-nkt/popup-hoat-dong-va-ho-tro-nkt/popup-hoat-dong-va-ho-tro-nkt.component';
import { KqDaoTaoVaBdNktComponent } from './pages/danh-muc-nhan-su/kq-dao-tao-va-bd-nkt/kq-dao-tao-va-bd-nkt.component';
import { PopupKqDaoTaoVaBdNktComponent } from './pages/danh-muc-nhan-su/kq-dao-tao-va-bd-nkt/popup-kq-dao-tao-va-bd-nkt/popup-kq-dao-tao-va-bd-nkt.component';
import { MucDoKyNangComponent } from './pages/danh-muc-nhan-su/muc-do-ky-nang/muc-do-ky-nang.component';
import { PopupMucDoKyNangComponent } from './pages/danh-muc-nhan-su/muc-do-ky-nang/popup-muc-do-ky-nang/popup-muc-do-ky-nang.component';
import { NdDaoTaoVaBdNktComponent } from './pages/danh-muc-nhan-su/nd-dao-tao-va-bd-nkt/nd-dao-tao-va-bd-nkt.component';
import { PopupNdDaoTaoBdNktComponent } from './pages/danh-muc-nhan-su/nd-dao-tao-va-bd-nkt/popup-nd-dao-tao-bd-nkt/popup-nd-dao-tao-bd-nkt.component';
import { PopupSuPhoiHopLucLuongComponent } from './pages/danh-muc-nhan-su/su-phoi-hop-luc-luong/su-phoi-hop-luc-luong/su-phoi-hop-luc-luong.component';
import { SuPhoiHopLucLuongComponent } from './pages/danh-muc-nhan-su/su-phoi-hop-luc-luong/su-phoi-hop-luc-luong.component';
import { CanBoQuanLyComponent } from './pages/thong-tin-nhan-su/popup-them-ttns/can-bo-quan-ly/can-bo-quan-ly.component';
import { GiaoVienNhanVienComponent } from './pages/thong-tin-nhan-su/popup-them-ttns/giao-vien-nhan-vien/giao-vien-nhan-vien.component';
import { SuaGiaoVienNhanVienComponent } from './pages/thong-tin-nhan-su/popup-ttns/sua-giao-vien-nhan-vien/sua-giao-vien-nhan-vien.component';
import { SuaCanBoQuanLyComponent } from './pages/thong-tin-nhan-su/popup-ttns/sua-can-bo-quan-ly/sua-can-bo-quan-ly.component';
import { KhaoSatComponent } from './pages/phieu/khao-sat/khao-sat.component';
import { PhieuHoiGiaoVienComponent } from './pages/phieu/phieu-hoi-giao-vien/phieu-hoi-giao-vien.component';
import { TypeOfPersonnelPipe } from '@ascschool/pipe/typeOfPersonnel.pipe';
import { NguoiThamGiaComponent } from './pages/danh-muc-nhan-su/nguoi-tham-gia/nguoi-tham-gia.component';
import { NoiDungDieuChinhComponent } from './pages/danh-muc-nhan-su/noi-dung-dieu-chinh/noi-dung-dieu-chinh.component';
import { KhoKhanTrongGdNktComponent } from './pages/danh-muc-nhan-su/kho-khan-trong-gd-nkt/kho-khan-trong-gd-nkt.component';
import { MongMuonCuaGvNvComponent } from './pages/danh-muc-nhan-su/mong-muon-cua-gv-nv/mong-muon-cua-gv-nv.component';
import { PopupNguoiThamGiaComponent } from './pages/danh-muc-nhan-su/nguoi-tham-gia/popup-nguoi-tham-gia/popup-nguoi-tham-gia.component';
import { PopupNoiDungDieuChinhComponent } from './pages/danh-muc-nhan-su/noi-dung-dieu-chinh/popup-noi-dung-dieu-chinh/popup-noi-dung-dieu-chinh.component';
import { PopupKhoKhanTrongGdNktComponent } from './pages/danh-muc-nhan-su/kho-khan-trong-gd-nkt/popup-kho-khan-trong-gd-nkt/popup-kho-khan-trong-gd-nkt.component';
import { PopupMongMuonCuaGvNvComponent } from './pages/danh-muc-nhan-su/mong-muon-cua-gv-nv/popup-mong-muon-cua-gv-nv/popup-mong-muon-cua-gv-nv.component';
import { KhaoSatNktComponent } from './pages/bao-cao/khao-sat-nkt/khao-sat-nkt.component';
import { TinhTranCanThiepComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/tinh-tran-can-thiep/tinh-tran-can-thiep.component';
import { PopupTinhTrangCanThiepComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/tinh-tran-can-thiep/popup-tinh-trang-can-thiep/popup-tinh-trang-can-thiep.component';
import { PhuongTienDieuChinhComponent } from './pages/danh-muc-nhan-su/phuong-tien-dieu-chinh/phuong-tien-dieu-chinh.component';
import { PopupPhuongTienDieuChinhComponent } from './pages/danh-muc-nhan-su/phuong-tien-dieu-chinh/popup-phuong-tien-dieu-chinh/popup-phuong-tien-dieu-chinh.component';
import { ChangePerPipe } from '@ascschool/pipe/change-per.pipe';
import { DsPhieuKhaoSatNhanSuComponent } from './pages/phieu/quan-ly/ds-phieu-khao-sat-nhan-su/ds-phieu-khao-sat-nhan-su.component';
import { ChiTietPhieuHoiGiaoVienComponent } from './pages/phieu/quan-ly/ds-phieu-khao-sat-nhan-su/chi-tiet-phieu-hoi-giao-vien/chi-tiet-phieu-hoi-giao-vien.component';
import { XemGiaoVienNhanVienComponent } from './pages/thong-tin-nhan-su/popup-xem-ttns/xem-giao-vien-nhan-vien/xem-giao-vien-nhan-vien.component';
import { XemCanBoQuanLyComponent } from './pages/thong-tin-nhan-su/popup-xem-ttns/xem-can-bo-quan-ly/xem-can-bo-quan-ly.component';
import { NoiSinhThuocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/noi-sinh/noi-sinh.component';
import { PopUpNoiSinhComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/noi-sinh/pop-up-noi-sinh/pop-up-noi-sinh.component';
import { ChuongTrinhHocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/chuong-trinh-hoc/chuong-trinh-hoc.component';
import { PopUpChuongTrinhHocComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/chuong-trinh-hoc/pop-up-chuong-trinh-hoc/pop-up-chuong-trinh-hoc.component';
import { ThoiDiemKhuyetTatComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/thoi-diem-khuyet-tat/thoi-diem-khuyet-tat.component';
import { PopUpThoiDiemKhuyetTatComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/thoi-diem-khuyet-tat/pop-up-thoi-diem-khuyet-tat/pop-up-thoi-diem-khuyet-tat.component';
import { PhuongTienHoTroNktComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/phuong-tien-ho-tro-nkt/phuong-tien-ho-tro-nkt.component';
import { PopupPhuongTienHoTroNktComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/phuong-tien-ho-tro-nkt/popup-phuong-tien-ho-tro-nkt/popup-phuong-tien-ho-tro-nkt.component';
import { BcCsgdTktptgdComponent } from './pages/bao-cao/csgd-tktptgd/csgd-tktptgd.component';
import { BcnsBcttddtComponent } from './pages/bao-cao/ns-bcttddt/ns-bcttddt.component';
import { BcnsTkslnstcsgdComponent } from './pages/bao-cao/ns-tkslnstcsgd/ns-tkslnstcsgd.component';
import { BcnktTkttnktComponent } from './pages/bao-cao/nkt-tkttnkt/nkt-tkttnkt.component';
import { BcnktBctkgdnktComponent } from './pages/bao-cao/nkt-bctkgdnkt/nkt-bctkgdnkt.component';
import { BcCsgdTkcsgdtcttComponent } from './pages/bao-cao/csgd-tkcsgdtctt/csgd-tkcsgdtctt.component';
import { BcCsgdTkcsvcgddbComponent } from './pages/bao-cao/csgd-tkcsvcgddb/csgd-tkcsvcgddb.component';
import { BcCsgdThttcsgdComponent } from './pages/bao-cao/csgd-thttcsgd/csgd-thttcsgd.component';
import { BcnsBcvbComponent } from './pages/bao-cao/ns-bcvb/ns-bcvb.component';
import { ChuyenNktComponent } from './pages/chuyen-nkt/chuyen-nkt.component';
import { ChuyenNktAouComponent } from './pages/chuyen-nkt/chuyen-nkt-aou/chuyen-nkt-aou.component';
import { NktCuaCsComponent } from './pages/chuyen-nkt/chuyen-nkt-aou/nkt-cua-cs/nkt-cua-cs.component';
import { ChuyenNktUComponent } from './pages/chuyen-nkt/chuyen-nkt-u/chuyen-nkt-u.component';
import { ChuyenNktTiepnhanComponent } from './pages/chuyen-nkt-tiepnhan/chuyen-nkt-tiepnhan.component';
import { ChuyenNktTiepnhanXulyComponent } from './pages/chuyen-nkt-tiepnhan/chuyen-nkt-tiepnhan-xuly/chuyen-nkt-tiepnhan-xuly.component';
import { KsnktTheoNhomTuoiComponent } from './pages/bao-cao-khao-sat-nkt/ksnkt-theo-nhom-tuoi/ksnkt-theo-nhom-tuoi.component';
import { KsnktDangTatComponent } from './pages/bao-cao-khao-sat-nkt/ksnkt-dang-tat/ksnkt-dang-tat.component';
import { KsnktMucDoKhuyetTatComponent } from './pages/bao-cao-khao-sat-nkt/ksnkt-muc-do-khuyet-tat/ksnkt-muc-do-khuyet-tat.component';
import { KsnktDangTatTuoiComponent } from './pages/bao-cao-khao-sat-nkt/ksnkt-dang-tat-tuoi/ksnkt-dang-tat-tuoi.component';
import { KsnktMucDoKhuyetTatTuoiComponent } from './pages/bao-cao-khao-sat-nkt/ksnkt-muc-do-khuyet-tat-tuoi/ksnkt-muc-do-khuyet-tat-tuoi.component';
import { KsnktDangTatTuoiGxnktComponent } from './pages/bao-cao-khao-sat-nkt/ksnkt-dang-tat-tuoi-gxnkt/ksnkt-dang-tat-tuoi-gxnkt.component';
import { BaoCaoThongKeNKTComponent } from './pages/bao-cao/bao-cao-thong-ke-nkt/bao-cao-thong-ke-nkt.component';
import { ViTriViecLamGiaoVienComponent } from './pages/danh-muc-nhan-su/vi-tri-viec-lam-giao-vien/vi-tri-viec-lam-giao-vien.component';
import { PopUpViTriViecLamGiaoVienComponent } from './pages/danh-muc-nhan-su/vi-tri-viec-lam-giao-vien/pop-up-vi-tri-viec-lam-giao-vien/pop-up-vi-tri-viec-lam-giao-vien.component';
import { NgheNghiepNguoiGiamHoComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/nghe-nghiep-nguoi-giam-ho/nghe-nghiep-nguoi-giam-ho.component';
import { PopUpNgheNghiepNguoiGiamHoComponent } from './pages/danh-muc-thuoc-nguoi-khuyet-tat/nghe-nghiep-nguoi-giam-ho/pop-up-nghe-nghiep-nguoi-giam-ho/pop-up-nghe-nghiep-nguoi-giam-ho.component';
import { TypeOfPersonelPipe } from '@ascschool/pipe/typeOfPersonelPipe.pipe';
import { BCPhieuThongTinNguoiKhuyetTatComponent } from './pages/bao-cao/bc-tt-nkt-phieu/bc-tt-nkt-phieu.component';
import { BcTtNnlComponent } from './pages/bao-cao/ns-bcttnnl/ns-bcttnnl.component';
import { BcTtCsgdComponent } from './pages/bao-cao/cs-bcttcsgd/cs-bcttcsgd.component';
import { BaoCaoThongKeTinhTrangGiaoDucComponent } from './pages/bao-cao/bao-cao-thong-ke-tinh-trang-giao-duc/bao-cao-thong-ke-tinh-trang-giao-duc.component';
import { BaoCaoThongKeHoTroGiaoDucComponent } from './pages/bao-cao/bao-cao-thong-ke-ho-tro-giao-duc/bao-cao-thong-ke-ho-tro-giao-duc.component';
import { BaoCaoThongKeTinhTrangCanThiepComponent } from './pages/bao-cao/bao-cao-thong-ke-tinh-trang-can-thiep/bao-cao-thong-ke-tinh-trang-can-thiep.component';
import { BaoCaoThongKeTinhTrangViecLamComponent } from './pages/bao-cao/bao-cao-thong-ke-tinh-trang-viec-lam/bao-cao-thong-ke-tinh-trang-viec-lam.component';
import { BaoCaoThongKeTinhTrangHonNhanComponent } from './pages/bao-cao/bao-cao-thong-ke-tinh-trang-hon-nhan/bao-cao-thong-ke-tinh-trang-hon-nhan.component';
import { BaoCaoThongKeDangSongTaiComponent } from './pages/bao-cao/bao-cao-thong-ke-dang-song-tai/bao-cao-thong-ke-dang-song-tai.component';
import { BaoCaoThongKeDieuKienTinhTeComponent } from './pages/bao-cao/bao-cao-thong-ke-dieu-kien-kinh-te/bao-cao-thong-ke-dieu-kien-kinh-te.component';
import { BaoCaoThongKeTheChatVanDongComponent } from './pages/bao-cao/bao-cao-thong-ke-the-chat-van-dong/bao-cao-thong-ke-the-chat-van-dong.component';
import { BaoCaoThongKeNhanThucComponent } from './pages/bao-cao/bao-cao-thong-ke-nhan-thuc/bao-cao-thong-ke-nhan-thuc.component';
import { BaoCaoThongKeNgonNguGiaoTiepComponent } from './pages/bao-cao/bao-cao-thong-ke-ngon-ngu-giao-tiep/bao-cao-thong-ke-ngon-ngu-giao-tiep.component';
import { BaoCaoThongKeTuPhucVuComponent } from './pages/bao-cao/bao-cao-thong-ke-tu-phuc-vu/bao-cao-thong-ke-tu-phuc-vu.component';
import { BaoCaoThongKeHanhViComponent } from './pages/bao-cao/bao-cao-thong-ke-hanh-vi/bao-cao-thong-ke-hanh-vi.component';
import { BaoCaoThongKeNhuCauHoTroGiaoDucComponent } from './pages/bao-cao/bao-cao-thong-ke-nhu-cau-ho-tro-giao-duc/bao-cao-thong-ke-nhu-cau-ho-tro-giao-duc.component';
import { BaoCaoThongKeChinhSachComponent } from './pages/bao-cao/bao-cao-thong-ke-chinh-sach/bao-cao-thong-ke-chinh-sach.component';
import { BaoCaoThongKeNKTCoGiayChungNhanComponent } from './pages/bao-cao/bao-cao-thong-ke-nkt-do-tuoi/bao-cao-thong-ke-nkt-do-tuoi.component';
import { BaoCaoThongKeTrucNKTCoGiayChungNhanComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-nkt-do-tuoi/bao-cao-thong-ke-truc-giay-chung-nhan.component';
import { BaoCaoThongKeTinhTrangGiaoDucTheoTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-tinh-trang-giao-duc/bao-cao-thong-ke-truc-tinh-trang-giao-duc.component';
import { BaoCaoThongKeTrucHoTroGiaoDucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-truc-ho-tro-giao-duc/bao-cao-thong-ke-truc-ho-tro-giao-duc.component';
import { BaoCaoThongKeTinhTrangCanThiepTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-tinh-trang-can-thiep-truc/bao-cao-thong-ke-tinh-trang-can-thiep-truc.component';
import { BaoCaoThongKeTinhTrangViecLamTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-tinh-trang-viec-lam-truc/bao-cao-thong-ke-tinh-trang-viec-lam-truc.component';
import { BaoCaoThongKeTinhTrangHonNhanTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-tinh-trang-hon-nhan-truc/bao-cao-thong-ke-tinh-trang-hon-nhan-truc.component';
import { BaoCaoThongKeDieuKienTinhTeTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-dieu-kien-kinh-te-truc/bao-cao-thong-ke-dieu-kien-kinh-te-truc.component';
import { BaoCaoThongKeDangSongTaiTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-dang-song-tai-truc/bao-cao-thong-ke-dang-song-tai-truc.component';
import { BaoCaoThongKeNhanThucTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-nhan-thuc-truc/bao-cao-thong-ke-nhan-thuc-truc.component';
import { BaoCaoThongKeNgonNguGiaoTiepTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-ngon-ngu-giao-tiep-truc/bao-cao-thong-ke-ngon-ngu-giao-tiep-truc.component';
import { BaoCaoThongKeTuPhucVuTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-tu-phuc-vu-truc/bao-cao-thong-ke-tu-phuc-vu-truc.component';
import { BaoCaoThongKeHanhViTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-hanh-vi-truc/bao-cao-thong-ke-hanh-vi-truc.component';
import { BaoCaoThongKeTheChatVanDongTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-the-chat-van-dong-truc/bao-cao-thong-ke-the-chat-van-dong-truc.component';
import { BaoCaoThongKeNhuCauHoTroGiaoDucTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-nhu-cau-ho-tro-giao-duc-truc/bao-cao-thong-ke-nhu-cau-ho-tro-giao-duc-truc.component';
import { BaoCaoThongKeChinhSachTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-chinh-sach-truc/bao-cao-thong-ke-chinh-sach-truc.component';
import { DistrictImportPupupComponent } from './pages/thong-tin-don-vi/dvql-cap-quan-huyen/import-quan-huyen/pop-up-import-quan-huyen.component';
import { ResetMatKhauComponent } from './pages/thong-tin-tai-khoan/reset-mat-khau/reset-mat-khau.component';
import { XacNhanOTPComponent } from './pages/thong-tin-tai-khoan/xac-nhan-otp/xac-nhan-otp.component';
import { ChuyenNhanSuComponent } from './pages/chuyen-nhan-su/chuyen-nhan-su.component';
import { ChuyenNhanSuUComponent } from './pages/chuyen-nhan-su/chuyen-nhan-su-u/chuyen-nhan-su-u.component';
import { ChuyenNhanSuAouComponent } from './pages/chuyen-nhan-su/chuyen-nhan-su-aou/chuyen-nhan-su-aou.component';
import { NhanSuCuaCsComponent } from './pages/chuyen-nhan-su/chuyen-nhan-su-aou/nhan-su-cua-cs/nhan-su-cua-cs.component';
import { ChuyenTiepNhanNhanSuComponent } from './pages/chuyen-tiep-nhan-nhan-su/chuyen-tiep-nhan-nhan-su.component';
import { ChuyenTiepNhanNhanSuPopupComponent } from './pages/chuyen-tiep-nhan-nhan-su/chuyen-tiep-nhan-nhan-su-popup/chuyen-tiep-nhan-nhan-su-popup.component';
import { BaoCaoThongKeGiayChungNhanTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-giay-chung-nhan/bao-cao-thong-ke-giay-chung-nhan.component';
import { BaoCaoThongKeCoSoCoNktTrucComponent } from './pages/bao-cao/bao-cao-ty-le-so-luong-nkt/bao-cao-thong-ke-co-so-co-nkt/bao-cao-thong-ke-co-so-co-nkt.component';
@NgModule({
  declarations: [
    ...NavigationComponents,
    ...FormComponent,
    ...MailComponent,
    ...DanhMucKhaoSatComponent,
    ProjectComponent,
    AutofocusDirective,
    BcCsGiaoDucComponent,
    BoardComponent,
    SettingsComponent,
    TableBtnRowExtendComponent,
    SearchDrawerComponent,
    SettingDrawerComponent,
    UserComponent,
    ThCbqlGvCbdhNktComponent,
    TtCaNhanComponent,
    ExceptionComponent,
    PhieuHoiGdNktComponent,
    ResizerComponent,
    HeaderComponent,
    Sample1Component,
    Sample2Component,
    PopupComponent,
    DrawerComponent,
    Sample5Component,
    TongHopTtVeNktComponent,
    ScoreConversionPipe,
    VanBangComponent,
    PopupVanBangComponent,
    PageBtnOptionExtendComponent,
    Sample7Component,
    Popup7Component,
    Drawer7Component,
    PopupInfoComponent,
    ImportComponent,
    TabContentComponent,
    TabContentPopupComponent,
    ContentContainerDirective,
    SettingSchoolComponent,
    Sample8Component,
    AddStudentComponent,
    Sample9Component,
    AddPersonnelComponent,
    HopDongComponent,
    TtLuongComponent,
    TrinhDoComponent,
    KhenthuongKyluatComponent,
    DemoComponent,
    DeletePersonelComponent,
    DeleteStudentComponent,
    ScrollLayoutComponent,
    ScrollLayoutNx1Component,
    MenuOptionComponent,
    TinhThanhComponent,
    PopUpTinhThanhComponent,
    ConfirmComponent,
    GenderPipe,
    TypeOfPersonelPipe,
    TypeOfPersonnelPipe,
    ConvertDatePipe,
    ChangePerPipe,
    EducationAndTrainingForPipe,
    DisDisabilityCertificateTypePipe,
    KeysPipe,
    DynamicPipe,
    TableBasicComponent,
    AscSelectComponent,
    DangKhuyetTatComponent,
    PopUpDangKhuyetTatComponent,
    MucDoComponent,
    PopUpMucDoComponent,
    KetQuaHocTapComponent,
    PopUpKetQuaHocTapComponent,
    ThanhTichComponent,
    PopUpThanhTichComponent,
    GiaoTiepXaHoiComponent,
    PopUpGiaoTiepXaHoiComponent,
    QuanHuyenComponent,
    PopupQuanHuyenComponent,
    KhaNangTuPhucVuComponent,
    PopUpKhaNangTuPhucVuComponent,
    HieuQuaHoTroYTeComponent,
    PopUpHieuQuaHoTroYTeComponent,
    NguoiChamSocComponent,
    PopUpNguoiChamSocComponent,
    NhuCauNKTComponent,
    PopUpNhuCauNKTComponent,
    ThongTinYTeComponent,
    PopUpThongTinYTeComponent,
    DieuKienSongComponent,
    PopUpDieuKienSongComponent,
    PhuongXaComponent,
    PopupPhuongXaComponent,
    ThuNhapHangThangComponent,
    PopUpThuNhapHangThangComponent,
    NguonThuNhapChinhComponent,
    PopUpNguonThuNhapChinhComponent,
    ChiTraHoTroNKTComponent,
    PopUpChiTraHoTroNKTComponent,
    DocLapVeKinhTeComponent,
    PopUpDocLapVeKinhTeComponent,
    TrinhDoHocVanComponent,
    PopUpTrinhDoHocVanComponent,
    DichVuThamGiaComponent,
    PopUpDichVuThamGiaComponent,
    TinhTrangGiaoDucComponent,
    PopUpTinhTrangGiaoDucComponent,
    LoaiHinhGiaoDucThamGiaComponent,
    PopUpLoaiHinhGiaoDucThamGiaComponent,
    LoaiHinhToChucComponent,
    PopUpLoaiHinhToChucComponent,
    HinhThucHoTroComponent,
    PopUpHinhThucHoTroComponent,
    NgheNghiepComponent,
    PopUpNgheNghiepComponent,
    MucDoQuanTamGiaDinhComponent,
    PopUpMucDoQuanTamGiaDinhComponent,
    DeXuatKienNghiComponent,
    PopUpDeXuatKienNghiComponent,
    DieuKienThamGiaGDComponent,
    PopupDanTocComponent,
    DanTocComponent,
    PopUpDieuKienThamGiaGDComponent,
    TonGiaoComponent,
    PopupTonGiaoComponent,
    PopUpDieuKienThamGiaGDComponent,
    HinhThucHocComponent,
    PopUpHinhThucHocComponent,
    LopHocComponent,
    PopUpLopHocComponent,
    LopHocNienHocComponent,
    PopUpLopHocNienHocComponent,
    CapTrucThuocComponent,
    PopUpCapTrucThuocComponent,
    PhuongThucGiaoDucComponent,
    PopUpPhuongThucGiaoDucComponent,
    QuocTichComponent,
    PopupQuocTichComponent,
    PopupNienHocComponent,
    NienHocComponent,
    LoaiNhanSuComponent,
    PopUpLoaiNhanSuComponent,
    ChucVuComponent,
    PopUpChucVuComponent,
    TrinhDoChuyenmonComponent,
    PopUpTrinhDoChuyenMonComponent,
    ChuyenNganhDaoTaoComponent,
    PopUpChuyenNganhDaoTaoComponent,
    LoaiCoSoComponent,
    PopupLoaiCoSoComponent,
    LoaiHinhComponent,
    PopupLoaiHinhComponent,
    KhuVucComponent,
    PopupKhuVucComponent,
    NgachComponent,
    PopUpNgachComponent,
    BacComponent,
    PopUpBacComponent,
    PhongBanComponent,
    PopUpPhongBanComponent,
    TrangThaiCanBoComponent,
    PopUpTrangThaiCanBoComponent,
    MonHocComponent,
    PopUpMonHocComponent,
    CapHocComponent,
    PopUpCapHocComponent,
    LoaiHopDongComponent,
    PopUpLoaiHopDongComponent,
    ThongTinNhanSuComponent,
    PopupThemTtnsComponent,
    PopupXemTtnsComponent,
    PopupTtnsComponent,
    PopupImportTtnsComponent,
    HocSinhComponent,
    ChuyenNktComponent,
    StudentAddPopupComponent,
    CertificateTakeCareOfStudentAddPopupComponent,
    StudentLearningProcessAddPopupComponent,
    PolicyOfStudentAddPopupComponent,
    TeacherInChargeAddPopupComponent,
    DisbilityOfStudentAddPopupComponent,
    StudentPopupComponent,
    CertificateTakeCareOfStudentPopupComponent,
    StudentLearningProcessPopupComponent,
    PolicyOfStudentPopupComponent,
    TeacherInChargePopupComponent,
    DisbilityOfStudentPopupComponent,
    NhomNguoiDungComponent,
    NhomQuanTriComponent,
    PopupNhomQuanTriComponent,
    SignInComponent,
    PopupThemChungChiComponent,
    PopupChungChiComponent,
    StudentImportPupupComponent,
    StudentViewComponent,
    SignInComponent,
    TrungTamGDDBComponent,
    XemTrungTamGDDBComponent,
    ThemTrungTamGDDBComponent,
    PopUpTrungTamGDDBComponent,
    DonViQuanLyComponent,
    XemDonViQuanLyComponent,
    ThemDonViQuanLyComponent,
    PopUpDonViQuanLyComponent,
    CoSoComponent,
    XemCoSoComponent,
    ThemCoSoComponent,
    PopUpCoSoComponent,
    PhanQuyenChucNangComponent,
    PopUpNhomNguoiDungComponent,
    QuanLyDanhSachCoSoComponent,
    PhanQuyenNhomNguoiDungComponent,
    NguoiDungHeThongComponent,
    ThemNguoiDungHeThongComponent,
    PopUpNguoiDungHeThongComponent,
    QuanLyDanhSachNguoiDungHeThongComponent,
    PhanQuyenNguoiDungHeThongComponent,
    QuanLyTkTrungTamGDDBComponent,
    CapNhatMatKhauComponent,
    QuanLyTkDonViQuanLyComponent,
    QuanLyTkCoSoComponent,
    PhanNhomQuyenComponent,
    PhanCongGiaoVienPhuTrachComponent,
    ThemGiaoVienPhuTrachComponent,
    DanhSachNguoiKhuyetTatComponent,
    ThemNguoiKhuyetTatComponent,
    PopUpGiaoVienPhuTrachComponent,
    ThongKeGdNktComponent,
    BcTtHtGdhnComponent,
    BcCsgdComponent,
    BcCsgdTktptgdComponent,
    BcnsBcttddtComponent,
    BcnsBcvbComponent,
    BcnsTkslnstcsgdComponent,
    BcnktTkttnktComponent,
    BcnktBctkgdnktComponent,
    BcCsgdTkcsgdtcttComponent,
    BcCsgdTkcsvcgddbComponent,
    BcCsgdThttcsgdComponent,
    PhanHeComponent,
    PopupPhanHeComponent,
    ChinhSuaLopHocNienHocComponent,
    SelectAutocompleteComponent,
    PopupBtnFooterComponent,
    PageBtnSearchComponent,
    PageBtnOptionComponent,
    TableBtnRowComponent,
    ThongTinNguoiDungComponent,
    DoiMatKhauComponent,
    TrichXuatThongTinPupupComponent,
    ThongBaoComponent,
    PopupThongBaoComponent,
    PopupViewThongBaoComponent,
    PopupUnViewThongBaoComponent,
    PopupXemNoiDungThongBaoComponent,
    NguyenNhanComponent,
    PopupNguyenNhanComponent,
    PopupLoaiChungNhanComponent,
    LoaiChungNhanComponent,
    TrinhDoDMComponent,
    PopupTrinhDoDMComponent,
    SchoolImportPupupComponent,
    TinhTrangHonNhanComponent,
    PopupTinhTrangHonNhanComponent,
    TinhTrangViecLamComponent,
    PopupTinhTrangViecLamComponent,
    MucDoPhatTrienComponent,
    PopupMucDoPhatTrienComponent,
    PopupLinhVucComponent,
    LinhVucComponent,
    PopupLevelOfDevComponent,
    PopupEditLevelOfDevComponent,
    PhieuHoiNktComponent,
    DsPhieuKhaoSatComponent,
    PopupDsPhieuKhaoSatComponent,
    DsPhieuKhaoSatNhanSuComponent,
    ChiTietPhieuHoiGiaoVienComponent,
    DvqlCapQuanHuyenComponent,
    ThemDvqlCapQuanHuyenComponent,
    SuaDvqlCapQuanHuyenComponent,
    XemDvqlCapQuanHuyenComponent,
    QuanLyTkDvqlQuanHuyenComponent,
    CamOnKhaoSatComponent,
    PhieuDanhGiaNktComponent,
    CoSoHaTangComponent,
    PopupCoSoHaTangComponent,
    LoaiPhuongTienHocLieuComponent,
    PopupLoaiPhuongTienComponent,
    //
    NoiDungDtbdcsgdhtgdComponent,
    PopupNoiDungDtbdcsgdhtgdComponent,
    MoiQuanHeVoiNktComponent,
    PopupMoiQuanHeVoiNktComponent,
    LoaiDtbdcsgdhtgdComponent,
    PopupDtbdcsgdhtgdComponent,
    LoaiKyNangComponent,
    PopupLoaiKyNangComponent,
    //
    CheDoThamGiaGdNktComponent,
    PopupCheDoThamGiaComponent,
    HoatDongVaHoTroNktComponent,
    PopupHoatDongVaHoTroNktComponent,
    KqDaoTaoVaBdNktComponent,
    PopupKqDaoTaoVaBdNktComponent,
    MucDoKyNangComponent,
    PopupMucDoKyNangComponent,
    NdDaoTaoVaBdNktComponent,
    PopupNdDaoTaoBdNktComponent,
    SuPhoiHopLucLuongComponent,
    PopupSuPhoiHopLucLuongComponent,
    GiaoVienNhanVienComponent,
    CanBoQuanLyComponent,
    //
    SuaGiaoVienNhanVienComponent,
    SuaCanBoQuanLyComponent,
    PhieuHoiGiaoVienComponent,
    KhaoSatComponent,
    //
    NguoiThamGiaComponent,
    PopupNguoiThamGiaComponent,
    NoiDungDieuChinhComponent,
    PopupNoiDungDieuChinhComponent,
    KhoKhanTrongGdNktComponent,
    PopupKhoKhanTrongGdNktComponent,
    MongMuonCuaGvNvComponent,
    PopupMongMuonCuaGvNvComponent,
    KhaoSatNktComponent,
    TinhTranCanThiepComponent,
    PopupTinhTrangCanThiepComponent,
    PopupPhuongTienDieuChinhComponent,
    PhuongTienDieuChinhComponent,
    //
    XemGiaoVienNhanVienComponent,
    XemCanBoQuanLyComponent,
    NoiSinhThuocComponent,
    PopUpNoiSinhComponent,
    ChuongTrinhHocComponent,
    PopUpChuongTrinhHocComponent,
    ThoiDiemKhuyetTatComponent,
    PopUpThoiDiemKhuyetTatComponent,
    PhuongTienHoTroNktComponent,
    PopupPhuongTienHoTroNktComponent,
    ChuyenNktAouComponent,
    NktCuaCsComponent,
    ChuyenNktUComponent,
    ChuyenNktTiepnhanComponent,
    ChuyenNktTiepnhanXulyComponent,
    KsnktTheoNhomTuoiComponent,
    KsnktDangTatComponent,
    KsnktMucDoKhuyetTatComponent,
    KsnktDangTatTuoiComponent,
    KsnktMucDoKhuyetTatTuoiComponent,
    KsnktDangTatTuoiGxnktComponent,
    BaoCaoThongKeNKTComponent,
    ViTriViecLamGiaoVienComponent,
    PopUpViTriViecLamGiaoVienComponent,
    NgheNghiepNguoiGiamHoComponent,
    PopUpNgheNghiepNguoiGiamHoComponent,
    BCPhieuThongTinNguoiKhuyetTatComponent,
    BcTtNnlComponent,
    BcTtCsgdComponent,
    BaoCaoThongKeNKTCoGiayChungNhanComponent,
    BaoCaoThongKeTinhTrangGiaoDucComponent,
    BaoCaoThongKeHoTroGiaoDucComponent,
    BaoCaoThongKeTinhTrangCanThiepComponent,
    BaoCaoThongKeTinhTrangViecLamComponent,
    BaoCaoThongKeTinhTrangHonNhanComponent,
    BaoCaoThongKeDangSongTaiComponent,
    BaoCaoThongKeDieuKienTinhTeComponent,
    BaoCaoThongKeTheChatVanDongComponent,
    BaoCaoThongKeNhanThucComponent,
    BaoCaoThongKeNgonNguGiaoTiepComponent,
    BaoCaoThongKeTuPhucVuComponent,
    BaoCaoThongKeHanhViComponent,
    BaoCaoThongKeNhuCauHoTroGiaoDucComponent,
    BaoCaoThongKeChinhSachComponent,
    BaoCaoThongKeTrucNKTCoGiayChungNhanComponent,
    BaoCaoThongKeTinhTrangGiaoDucTheoTrucComponent,
    BaoCaoThongKeTrucHoTroGiaoDucComponent,
    BaoCaoThongKeTinhTrangCanThiepTrucComponent,
    BaoCaoThongKeTinhTrangViecLamTrucComponent,
    BaoCaoThongKeTinhTrangHonNhanTrucComponent,
    BaoCaoThongKeDieuKienTinhTeTrucComponent,
    BaoCaoThongKeDangSongTaiTrucComponent,
    BaoCaoThongKeNhanThucTrucComponent,
    BaoCaoThongKeNgonNguGiaoTiepTrucComponent,
    BaoCaoThongKeTuPhucVuTrucComponent,
    BaoCaoThongKeHanhViTrucComponent,
    BaoCaoThongKeTheChatVanDongTrucComponent,
    BaoCaoThongKeNhuCauHoTroGiaoDucTrucComponent,
    BaoCaoThongKeChinhSachTrucComponent,
    DistrictImportPupupComponent,
    ResetMatKhauComponent,
    XacNhanOTPComponent,
    ChuyenNhanSuComponent,
    ChuyenNhanSuUComponent,
    ChuyenNhanSuAouComponent,
    NhanSuCuaCsComponent,
    ChuyenTiepNhanNhanSuComponent,
    ChuyenTiepNhanNhanSuPopupComponent,
    BaoCaoThongKeGiayChungNhanTrucComponent,
    BaoCaoThongKeCoSoCoNktTrucComponent
  ],
  imports: [
    // CKEditorModule,
    EditorModule,
    NzTypographyModule,
    NzTreeModule,
    CommonModule,
    NzTreeSelectModule,
    NzSwitchModule,
    NzLayoutModule,
    NzGridModule,
    NzSpaceModule,
    NzListModule,
    NzDatePickerModule,
    NzCardModule,
    NzAutocompleteModule,
    ProjectRoutingModule,
    NzIconModule.forChild(NZ_NDHUY_ICONS),
    KeyboardShortcutsModule.forRoot(),
    NzIconModule,
    NzToolTipModule,
    NzModalModule,
    NzDropDownModule,
    NzSelectModule,
    NzNotificationModule,
    NzDrawerModule,
    NzPopoverModule,
    DragDropModule,
    NzButtonModule,
    NzInputModule,
    NzTableModule,
    NzDividerModule,
    NzUploadModule,
    TextFieldModule,
    NzRadioModule,
    FormsModule,
    ReactiveFormsModule,
    AscControlModule,
    ContentLoaderModule,
    QuillModule,
    NzPopconfirmModule,
    TranslateModule,
    NzMessageModule,
    NzCheckboxModule,
    ScrollingModule,
    NzFormModule,
    NzDatePickerModule,
    NzMenuModule,
    NzTabsModule,
    NzAvatarModule,
    NzPaginationModule,
    NzInputNumberModule,
    NzCommentModule,
    NzRateModule,
    NzAffixModule,
    NzBadgeModule,
    NzCarouselModule,
    NzTagModule,
    HighchartsChartModule,
    NzResultModule,
  ],
  providers: [
    TabService,
    DatePipe,
    GenderPipe,
    TypeOfPersonnelPipe,
    DisDisabilityCertificateTypePipe,
    TypeOfPersonelPipe
  ],
  entryComponents: [
    Sample1Component,
    Sample2Component,
    Sample5Component,
    Sample7Component,
    SettingsComponent,
    BoardComponent,
    TtCaNhanComponent,
    HopDongComponent,
    TtLuongComponent,
    TrinhDoComponent,
    KhenthuongKyluatComponent,
    DemoComponent,
  ]
})
export class ProjectModule { }
